import React, { PureComponent } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import cx from 'classnames';

// Component.
import ModalExitIcon from 'components/Icons/Menu/ExitIcon';

// Styles.
import styles from './styles.module.scss';

// Images.

export default class WelltoryModal extends PureComponent {

  static defaultProps = {
    header: null,
    body: null,
    footer: null,
  };

  onClickModalExit = (e) => {
    this.props.hideModal();
  };

  render() {

    return (
      <Modal
        backdrop="static"
        dialogClassName={cx(styles.welltoryModal, { [styles.isEmptyFooter]: this.props.footer === null })}
        show={this.props.isShowModal}
        onHide={this.onClickModalExit}
      >
        <div className={styles.exit} onClick={this.onClickModalExit}>
          <ModalExitIcon />
        </div>
        <Modal.Header>
          {this.props.header}
        </Modal.Header>
        {this.props.body &&
          <Modal.Body className={styles.dashboardFreeUserModalBody}>
            {this.props.body}
          </Modal.Body>
        }
        <Modal.Footer className={cx(styles.dataSourceActiveModalFooter)}>
          {this.props.footer}
        </Modal.Footer>
      </Modal>
    );
  }

}
